// Anmeldebildschirm. Bewusst schmucklos: zwei Felder, ein Knopf.

import { useState, type FormEvent } from "react";
import { useZustand } from "../zustand.tsx";

export function Anmeldung() {
  const { anmelden } = useZustand();
  const [email, setzeEmail] = useState("");
  const [passwort, setzePasswort] = useState("");
  const [fehler, setzeFehler] = useState<string | null>(null);
  const [laeuft, setzeLaeuft] = useState(false);

  async function absenden(e: FormEvent) {
    e.preventDefault();
    setzeFehler(null);
    setzeLaeuft(true);
    try {
      await anmelden(email, passwort);
    } catch (f) {
      setzeFehler(f instanceof Error ? f.message : "Anmeldung fehlgeschlagen.");
    } finally {
      setzeLaeuft(false);
    }
  }

  return (
    <div className="anmeldung">
      <form className="anmeldung-karte" onSubmit={absenden}>
        <div className="anmeldung-marke">
          <span className="dot" />
          <b>Immofolio</b>
        </div>

        {fehler ? <div className="anmeldung-fehler">{fehler}</div> : null}

        <label className="fld">
          <span>E-Mail</span>
          <input type="email" value={email} autoComplete="username" required
            autoCapitalize="none" spellCheck={false}
            onChange={(e) => setzeEmail(e.target.value)} />
        </label>
        <label className="fld">
          <span>Passwort</span>
          <input type="password" value={passwort} autoComplete="current-password" required
            onChange={(e) => setzePasswort(e.target.value)} />
        </label>

        <button className="btn btn-primary" type="submit" disabled={laeuft}>
          {laeuft ? "Einen Moment …" : "Anmelden"}
        </button>

        <p className="hint">
          Konten legt der Betreiber auf dem Server an. Es gibt keine Registrierung
          und keine Passwort-vergessen-Mail.
        </p>
      </form>
    </div>
  );
}
